import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Es material digital?',
  answer: 'Sí, es 100% digital. Recibís el acceso a tu correo electrónico inmediatamente después de la compra para descargar en tu computadora, tablet o celular.'
}, {
  question: '¿Sirve para aula y hogar?',
  answer: 'Absolutamente. Los recursos están diseñados para ser flexibles y pueden utilizarse tanto en el contexto escolar como en casa para reforzar aprendizajes.'
}, {
  question: '¿Puedo usarlo en sesiones presenciales y online?',
  answer: 'Sí, el formato digital te permite compartir pantalla en clases virtuales o imprimir el material para sesiones presenciales.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No. El material es intuitivo, organizado y viene listo para usar. No necesitás ser experto para aplicarlo con éxito.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'El acceso es de por vida. Una vez que comprás, el material es tuyo para siempre, incluyendo futuras actualizaciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="max-w-3xl mx-auto space-y-4" data-id="element-16">
      {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-id="element-17">
          <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-18">
            <span className="font-bold text-gray-900 text-lg" data-id="element-19">
              {faq.question}
            </span>
            {openIndex === idx ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-20" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-21" />}
          </button>
          {openIndex === idx && <div className="p-5 pt-0 bg-white text-gray-600 border-t border-gray-100" data-id="element-22">
              <p className="mt-4" data-id="element-23">{faq.answer}</p>
            </div>}
        </div>)}
    </div>;
}